import React, { useEffect, useMemo, useState, useRef } from 'react';
import NyTaskItem from './NyTaskItem';
import { image } from '../../../utils/data/baseUrl';
import classNames from 'classnames';
import NyTaskWinners from './NyTaskWinners';
import NyTaskPrize from './NyTaskPrize';
import { safeHTML } from '../../../utils/safeHTML';
import { useTranslation } from '../../../translations';
import { convertDateFormat } from '../../../utils/helpers/helpers';

const NyTaskSection = React.forwardRef(function NyTaskSection(
  {
    item: { list, title, prize_image, prize_description, prize_description_2, prizes, ...rest },
    activeCondition,
    callbacks,
    winners,
    openQuizModal,
    onClick,
    getQuestTaskState,
    isPrizes = false,
  },
  ref,
) {
  const sectionBlockRef = useRef();
  const { t, i18n } = useTranslation();
  const [height, setHeight] = useState(0);

  useEffect(() => {
    const height = Number(activeCondition && (sectionBlockRef?.current?.clientHeight ?? 0));
    setHeight(height);
  });

  const filteredList = useMemo(() => {
    return list?.filter((item) => item.prize);
  }, [list]);

  const prizeType = !!prizes?.length
    ? 'multiPrizes'
    : [prize_image, prize_description, prize_description_2].every(Boolean) && 'singlePrize';

  const formattedTitle = convertDateFormat(title, i18n.language);
  const sectionTitle = t('nyTaskContent.item.week', { value: formattedTitle });

  return (
    <div className={classNames('ny-task__section', { 'ny-task__section_active': activeCondition })}>
      <div className={`ny-task__section-header`} onClick={onClick}>
        <h3 className={'ny-task__section-title'}>{safeHTML(sectionTitle)}</h3>

        <img
          className={classNames('ny-task__section-arrow', {
            'ny-task__section-arrow_reverse': activeCondition,
          })}
          src={image('tasks/arrow-2.svg')}
          alt={'faq-arrow'}
        />
      </div>
      <div className={'ny-task__section-content'} style={{ height: `${height}px` }}>
        <ul className={'ny-task__section-block'} ref={sectionBlockRef}>
          {{
            multiPrizes() {
              return <NyTaskPrize prizes={prizes} />;
            },
            singlePrize() {
              return (
                <NyTaskWinners
                  callbacks={callbacks}
                  key={`task-item-winners`}
                  {...winners}
                  img={prize_image}
                  description={prize_description}
                  subDescription={prize_description_2}
                />
              );
            },
          }[prizeType]?.()}

          {filteredList?.map((el, index) => (
            <NyTaskItem
              callbacks={callbacks}
              key={`task-item-${index}`}
              isWin={el.correctAnswersCount >= el.correct_answers_requirement}
              state={getQuestTaskState(el)}
              openQuizModal={openQuizModal}
              el={el}
              index={index}
            />
          ))}
        </ul>
      </div>
    </div>
  );
});
export default NyTaskSection;
NyTaskSection.propTypes = {};
